/**
 * Redirect to Open Box searchUrl (search page result)
 * @param {string} searchUrl
 */
function redirectToOpenBoxSearch (searchUrl) {

	const adjustedSearchUrl = searchUrl.replace('#', '');
	const searchPartialUrl = `/s/sales_open-box/${adjustedSearchUrl}?s=1`;

	// redirect to search result page
	window.location.href = searchPartialUrl;

}

export default redirectToOpenBoxSearch;
